import React, { useContext, useEffect, useState } from "react";
import { decodeToken } from "react-jwt";
import { AuthContext } from "../../components/user/BCPAuthProvider";
import { useParams, useNavigate } from "react-router-dom";
import {
  findGetParameter,
  getData
} from "../../components/utilities/UtilityFunctions";
import { postNotification } from "../../components/utilities/Notifications";
import { getPairingMenuItems } from "../events/components/EventFunctions";
import ModalLoadingFull from "../../components/modals/ModalLoadingFull";
import Pairing from "./Pairing";
import TeamPairing from "./TeamPairing";
import { handlePagingAll } from "../../components/api/APIUtilities";
import { doFormula } from "../../components/utilities/FormUtilities";
import { useSetBcpEvent } from "../../components/user/BCPAuthReducers";
import moment from "moment";
import { LinearProgress } from "@mui/material";
import { useTranslation } from "react-i18next";

const jwt = findGetParameter("jwt");

export const calculateTeamResults = (teamPairing, scorecard) => {
  let modifierGameDataDict = {};
  if (teamPairing?.modifiers?.length) {
    for (let modifier of teamPairing.modifiers) {
      for (let key1 of Object.keys(modifier.gameData)) {
        for (let key2 of Object.keys(modifier.gameData[key1])) {
          if (modifierGameDataDict[key1] === undefined) {
            modifierGameDataDict[key1] = {};
          }
          if (modifierGameDataDict[key1][key2] === undefined) {
            modifierGameDataDict[key1][key2] = 0;
          }
          modifierGameDataDict[key1][key2] += modifier.gameData[key1][key2];
        }
      }
    }
  }

  let resultDict = {};
  if (scorecard?.template?.rows?.length) {
    for (let row of scorecard?.template?.rows) {
      if (row.cols) {
        for (let col of row.cols) {
          if (col.id) {
            if (col.calcType === "sum") {
              resultDict[col.id] = 0;
              if (col.teamPlayer !== undefined) {
                for (let pairing of teamPairing.pairings) {
                  resultDict[col.id] +=
                    pairing[`player${col.teamPlayer}Game`]?.[col.metric] || 0;
                }
              }
            } else if (col.calcType === "count") {
              resultDict[col.id] = teamPairing.pairings?.length || 0;
            } else if (col.formula) {
              resultDict[col.id] = doFormula(col, resultDict);
            } else if (col.bcpfield) {
              let fields = col.bcpfield.split(".");
              let value = teamPairing;
              for (let field of fields) {
                if (value !== undefined) {
                  value = value[field];
                }
              }
              if (value !== undefined) {
                resultDict[col.id] = value;
              }
            }

            if (resultDict[col.id] === undefined) {
              resultDict[col.id] = 0;
            } else if (col.subType === "number") {
              resultDict[col.id] = parseFloat(resultDict[col.id]);
            }

            if (col.bcpfield) {
              let fields = col.bcpfield.split(".");
              if (fields.length === 2) {
                let modifier = modifierGameDataDict?.[fields[0]]?.[fields[1]];
                if (modifier !== undefined) {
                  resultDict[col.id] += modifier;
                }
              }
            }
          }
        }
      }
    }
  }

  return resultDict;
};

export default function GameRouter(props) {
  const {
    setEvent,
    setItemsMiddle,
    pType,
    objId,
    modal,
    setRefreshPairings,
    event,
    setSwapTableModal,
    setP,
    preview,
    setModalOpen
  } = props;

  const { t } = useTranslation("translation", {
    keyPrefix: "misc.pairings"
  });

  let { pairingType, objectId } = useParams();

  if (!pairingType && !objectId && pType && objId) {
    pairingType = pType;
    objectId = objId;
  }

  const navigate = useNavigate();
  const authContext = useContext(AuthContext);
  const setBcpEvent = useSetBcpEvent();

  const useGSD = findGetParameter("useGSD");
  const scorecardId = findGetParameter("scorecardId") || props?.scorecard?.id;

  const [loading, setLoading] = useState(true);
  const [pairing, setPairing] = useState(null);

  const getPairing = async () => {
    try {
      let pairingId = objectId;
      var queryStringParameters = {
        pairingType:
          pairingType?.toLowerCase() === "pairing"
            ? "Pairing"
            : pairingType?.toLowerCase() === "teampairing"
              ? "TeamPairing"
              : pairingType?.toLowerCase() === "seatedpairing" ||
                  pairingType?.toLowerCase() === "bcpseatedpairing"
                ? "SeatedPairing"
                : pairingType.toLowerCase() === "casualpairing"
                  ? "CasualPairing"
                  : null
      };

      queryStringParameters["expand[]"] =
        queryStringParameters.pairingType !== "CasualPairing"
          ? [
              "event",
              "teamPairing",
              "players",

              "player1",
              "player1Game",

              "player2",
              "player2Game",

              "teamPlayer1",
              "teamPlayer2",

              "secondaryPairing"
            ]
          : ["teamPairing", "gameSystem"];

      if (jwt && jwt !== "") {
        queryStringParameters.jwt = jwt;

        let decodedToken = decodeToken(jwt);
        if (decodedToken?.pairingId) {
          pairingId = decodedToken.pairingId;
          queryStringParameters.pairingType = "Pairing";
        } else if (decodedToken?.teamPairingId) {
          pairingId = decodedToken.teamPairingId;
          queryStringParameters.pairingType = "TeamPairing";
        } else if (decodedToken?.seatedPairingId) {
          pairingId = decodedToken.seatedPairingId;
          queryStringParameters.pairingType = "SeatedPairing";
        } else if (decodedToken?.casualPairingId) {
          pairingId = decodedToken.casualPairingId;
          queryStringParameters.pairingType = "CasualPairing";
        }
      }

      var apiPairingData = await getData(`/pairings/${pairingId}`, {
        queryStringParameters: queryStringParameters
      });

      if (
        apiPairingData.primaryPairingId &&
        apiPairingData.secondaryPairingId === apiPairingData.id
      ) {
        apiPairingData = await getData(
          `/pairings/${apiPairingData.primaryPairingId}`,
          {
            queryStringParameters: queryStringParameters
          }
        );
      }

      if (apiPairingData.event) {
        if (
          apiPairingData.jwt?.userId ||
          authContext?.authState?.identity?.userId
        ) {
          var apiEventRole = await getData(
            `/events/${apiPairingData.event.id}/role`,
            {
              queryStringParameters: {
                userId:
                  apiPairingData.jwt?.userId ||
                  authContext?.authState?.identity?.userId,
                jwt: jwt
              }
            }
          );
          apiPairingData.event.role = apiEventRole;
          apiPairingData.event.isTO =
            apiEventRole?.id !== undefined ||
            authContext?.authState?.identity?.isAdmin === true ||
            authContext?.authState?.identity?.adminGameSystems?.includes(
              apiEventRole?.gameSystemId
            ); // TODO: implement permissions
        }

        if (apiPairingData.event.gameSystemId) {
          var apiGameSystem = await getData(
            `/gamesystems/${apiPairingData.event.gameSystemId}`
          );
          apiPairingData.gameSystem = apiGameSystem;
        }
      }

      var getScorecardId = undefined;

      if (
        apiPairingData.pairingType === "TeamPairing" &&
        !apiPairingData.event?.doublesEvent
      ) {
        apiPairingData.teamActivePlayerSize =
          apiPairingData.teamActivePlayerSize ||
          apiPairingData.event?.teamActivePlayerSize;
        if (apiPairingData.teamActivePlayerSize === undefined) {
          apiPairingData.teamActivePlayerSize = Math.max(
            apiPairingData.teamPlayer1?.players?.length || 0,
            apiPairingData.teamPlayer2?.players?.length || 0
          );
        }

        if (apiPairingData.teamActivePlayerSize) {
          apiPairingData.pairings = [];
          for (let i = 0; i < apiPairingData.teamActivePlayerSize; i++) {
            apiPairingData.pairings.push({ table: i + 1 });
          }
        }

        var apiPairingsData = await handlePagingAll("/pairings", {
          pairingType: "Pairing",
          teamPairingId: apiPairingData.id,
          "expand[]": ["player1", "player1Game", "player2", "player2Game"]
        });

        if (apiPairingsData?.length) {
          apiPairingData.isPaired = true;

          apiPairingsData.sort((a, b) => {
            if (a.table === b.table) {
              if (a.primaryPairingId) {
                return a.primaryPairingId === a.id ? -1 : 1;
              }
            }

            return (a.table || 0) - (b.table || 0);
          });

          apiPairingData.pairings = apiPairingsData;

          if (apiPairingsData.length < apiPairingData.pairings.length) {
            for (let i = 0; i < apiPairingData.pairings.length; i++) {
              apiPairingData.pairings.push({});
            }
          }
        }

        if (scorecardId) {
          getScorecardId = scorecardId;
        } else if (useGSD && apiPairingData?.event?.isTo) {
          if (apiPairingData?.event?.doublesEvent) {
            getScorecardId =
              apiPairingData.event?.gameSystem?.scorecardId ||
              apiPairingData.gameSystem?.scorecardId;
          } else {
            getScorecardId =
              apiPairingData.event?.gameSystem?.teamScorecardId ||
              apiPairingData.gameSystem?.teamScorecardId;
          }
        } else if (apiPairingData.scorecardUsedId) {
          getScorecardId = apiPairingData.scorecardUsedId;
        } else if (
          apiPairingData.scorecardId &&
          apiPairingData.scorecardId !== apiPairingData.event?.scorecardId // legacy teamPairings
        ) {
          getScorecardId = apiPairingData.scorecardId;
        } else {
          getScorecardId =
            apiPairingData.event?.teamScorecardId ||
            apiPairingData.event?.gameSystem?.teamScorecardId ||
            apiPairingData.gameSystem?.teamScorecardId;
        }
      } else {
        if (apiPairingData.pairingType === "SeatedPairing") {
          apiPairingData.tableSize = apiPairingData.seatedPlayers?.length || 0;
          if (apiPairingData.seatedPlayers?.length) {
            let playerNo = 0;
            for (let seatedPlayer of apiPairingData.seatedPlayers) {
              playerNo++;
              apiPairingData[`player${playerNo}Id`] = seatedPlayer.playerId;
              apiPairingData[`player${playerNo}`] = seatedPlayer;
              if (apiPairingData.games?.[seatedPlayer.playerId]) {
                apiPairingData[`player${playerNo}GameId`] =
                  apiPairingData.games?.[seatedPlayer.playerId].gameId;
                apiPairingData[`player${playerNo}Game`] =
                  apiPairingData.games?.[seatedPlayer.playerId];
              }
            }
          }
        }
        if (scorecardId) {
          getScorecardId = scorecardId;
        } else if (useGSD && apiPairingData?.event?.isTo) {
          getScorecardId =
            apiPairingData?.event?.gameSystem?.scorecardId ||
            apiPairingData?.gameSystem?.scorecardId;
        } else if (apiPairingData?.scorecardUsedId) {
          getScorecardId = apiPairingData?.scorecardUsedId;
        } else if (apiPairingData?.scorecardId) {
          getScorecardId = apiPairingData?.scorecardId;
        } else {
          getScorecardId =
            apiPairingData?.event?.scorecardId ||
            apiPairingData?.event?.gameSystem?.scorecardId ||
            apiPairingData?.gameSystem?.scorecardId;
        }
      }

      if (getScorecardId) {
        apiPairingData.scorecard = await getData(
          `/scorecards/${getScorecardId}`,
          {
            queryStringParameters: {
              "expand[]": ["lists"]
            }
          }
        );

        if (
          apiPairingData.pairingType === "TeamPairing" &&
          !apiPairingData.event?.doublesEvent
        ) {
          apiPairingData.results = calculateTeamResults(
            apiPairingData,
            apiPairingData.scorecard
          );
        }
      }

      if (apiPairingData.event) {
        if (props?.setEvent)
          setEvent({ ...apiPairingData.event, round: apiPairingData.round });

        if (props?.setItemsMiddle)
          setItemsMiddle(getPairingMenuItems(apiPairingData, props?.appRoute));

        setBcpEvent(apiPairingData.event);

        if (apiPairingData.event.doublesEvent) {
          if (apiPairingData.teamPlayer1) {
            apiPairingData.player1 = {
              ...apiPairingData.teamPlayer1,
              firstName: apiPairingData.teamPlayer1.name,
              userId: apiPairingData.teamPlayer1.teamCaptainId
            };
          }
          if (apiPairingData.teamPlayer2) {
            apiPairingData.player2 = {
              ...apiPairingData.teamPlayer2,
              firstName: apiPairingData.teamPlayer2.name,
              userId: apiPairingData.teamPlayer2.teamCaptainId
            };
          }
        }
      }

      apiPairingData.showButtons = false;
      apiPairingData.needsPins = true;
      apiPairingData.readOnly = true;
      apiPairingData.validPins = false;

      if (apiPairingData?.pairingCollection === "BCPCasualPairing") {
        if (
          authContext?.authState?.identity?.userId &&
          (apiPairingData?.ownerID ===
            authContext?.authState?.identity?.userId ||
            apiPairingData?.player1?.userId ===
              authContext?.authState?.identity?.userId ||
            apiPairingData?.player2?.userId ===
              authContext?.authState?.identity?.userId)
        ) {
          // TODO: check seated players

          apiPairingData.event = {
            passwordlessScoring: true,
            isTO: true
          };

          apiPairingData.showButtons = true;
          apiPairingData.readOnly = false;
          apiPairingData.validPins = true;
          apiPairingData.needsPins = false;
        }
      } else if (apiPairingData.event?.isTO) {
        // Tournament Organiser: Unlocked and Pins not required
        apiPairingData.showButtons = true;
        apiPairingData.readOnly = false;
        apiPairingData.needsPins = false;
        apiPairingData.validPins = true;
        if (apiPairingData.isDone) {
          postNotification("info", t("scorecardSubmitted"));
        }
      } else if (
        !apiPairingData.event?.enablePasswords &&
        !apiPairingData.event?.passwordlessScoring
      ) {
        // no self scoring
      } else if (
        apiPairingData.event?.ended ||
        apiPairingData.event?.currentRound !== apiPairingData.round
      ) {
        // not current round
      } else if (apiPairingData.isDone) {
        // Game is submitted
        apiPairingData.showButtons = !apiPairingData.event?.passwordlessScoring;
        if (apiPairingData.scorecard?.requiresUnlock === false) {
          // Game not submitted and scorecard doesn't need to be unlocked: Unlocked and Pins not required
          apiPairingData.readOnly = false;
        }
      } else if (apiPairingData.pairingType === "TeamPairing") {
        // teams event
        if (apiPairingData.teamPlayer1 && apiPairingData.teamPlayer2) {
          if (apiPairingData.event?.passwordlessScoring) {
            apiPairingData.showButtons = false;
            apiPairingData.needsPins = false;
            // check if they are one of the captains
            if (
              !authContext?.authState?.identity?.userId &&
              !apiPairingData?.jwt?.userId
            ) {
              // not logged in, should we prompt the user to login?
            } else {
              if (
                apiPairingData.teamPlayer1?.teamCaptainId ===
                  authContext?.authState?.identity?.userId ||
                apiPairingData.teamPlayer2?.teamCaptainId ===
                  authContext?.authState?.identity?.userId ||
                apiPairingData.teamPlayer1?.teamCaptainId ===
                  apiPairingData.jwt?.userId ||
                apiPairingData.teamPlayer2?.teamCaptainId ===
                  apiPairingData.jwt?.userId
              ) {
                apiPairingData.showButtons = true;
                if (apiPairingData.event?.doublesEvent) {
                  // not sure if this should be only for doubles events
                  apiPairingData.readOnly = false;
                }
              } else {
                // check team 1 players
                for (let p of apiPairingData.teamPlayer1.players) {
                  apiPairingData.showButtons =
                    p.userId === authContext?.authState?.identity?.userId ||
                    p.userId === apiPairingData.jwt?.userId;
                  if (apiPairingData.showButtons) {
                    apiPairingData.readOnly = false;
                    break;
                  }
                }
                for (let p of apiPairingData.teamPlayer1.nonPlayingMembers) {
                  apiPairingData.showButtons =
                    p.userId === authContext?.authState?.identity?.userId ||
                    p.userId === apiPairingData.jwt?.userId;
                  if (apiPairingData.showButtons) {
                    apiPairingData.readOnly = false;
                    break;
                  }
                }
                if (!apiPairingData.showButtons) {
                  // check team 2 players
                  for (let p of apiPairingData.teamPlayer2.players) {
                    apiPairingData.showButtons =
                      p.userId === authContext?.authState?.identity?.userId ||
                      p.userId === apiPairingData.jwt?.userId;
                    if (apiPairingData.showButtons) {
                      apiPairingData.readOnly = false;
                      break;
                    }
                  }
                  for (let p of apiPairingData.teamPlayer2.nonPlayingMembers) {
                    apiPairingData.showButtons =
                      p.userId === authContext?.authState?.identity?.userId ||
                      p.userId === apiPairingData.jwt?.userId;
                    if (apiPairingData.showButtons) {
                      apiPairingData.readOnly = false;
                      break;
                    }
                  }
                }
              }
            }
          } else {
            apiPairingData.showButtons = true;
            if (apiPairingData.scorecard?.requiresUnlock === false) {
              // Game not submitted and scorecard doesn't need to be unlocked: Unlocked and Pins not required
              apiPairingData.readOnly = false;
            }
          }
        }
      } else if (
        !apiPairingData.teamPairing &&
        (!apiPairingData.player1 || !apiPairingData.player2)
      ) {
        // Game has a bye player but not part of a team match
      } else if (
        apiPairingData.teamPairing &&
        (!apiPairingData.teamPairing?.teamPlayer1 ||
          !apiPairingData.teamPairing?.teamPlayer2)
      ) {
        // Game is part of a bye team match
      } else if (
        (authContext?.authState?.identity?.userId ||
          apiPairingData.jwt?.userId) &&
        apiPairingData.activeUsers?.[
          authContext?.authState?.identity?.userId || apiPairingData.jwt?.userId
        ]
      ) {
        // Game not submitted and user already active: Unlocked and Pins not required
        apiPairingData.showButtons = true;
        apiPairingData.readOnly = false;
        apiPairingData.validPins = true;
        apiPairingData.needsPins = false;
      } else if (
        apiPairingData.scorecard?.requiresUnlock === false &&
        apiPairingData.event?.enablePasswords
        // !apiPairingData.event?.passwordlessScoring
      ) {
        // Game not submitted and scorecard doesn't need to be unlocked: Unlocked and Pins not required
        apiPairingData.showButtons = true;
        apiPairingData.readOnly = false;
      }

      setLoading(false);
      setPairing(apiPairingData);
    } catch (err) {
      postNotification("error", err);
      if (modal) {
        setModalOpen(false);
      } else navigate("/");
    }
  };

  // Creates a fake pairing for scorecard previews
  const getPreview = () => {
    const createPlayer = (playerNum) => ({
      dropped: false,
      firstName: "Player",
      lastName: playerNum,
      id: `Player${playerNum}Id`,
      userId: `Player${playerNum}UserId`
    });

    const tempPairing = {
      scorecard: props?.scorecard,
      scorecardId:
        event?.scorecardId || event?.scorecard?.id || props?.scorecard?.id,
      pairingType: "Pairing",
      pairingCollection: "Pairing",
      isDone: false,
      needsPins: false,
      created_at: moment().format("YYYY-MM-DDTHH:mm"),
      cacheRecord: true,
      dnEvent: { id: "", name: event?.name || "Event Name" },
      event,
      eventId: event?.id || "eventId",
      gameSystem: event?.gameSystem,
      podNum: 1,
      readOnly: false,
      showButtons: false,
      table: 1,
      validPins: true
    };

    const numOfPlayers =
      event?.boardGameEvent || event?.gameSystem?.boardGameEvent ? 4 : 2;

    for (let i = 1; i < numOfPlayers + 1; i++) {
      tempPairing[`player${i}`] = createPlayer(i);
      tempPairing[`player${i}Id`] = `Player${i}Id`;
    }

    setPairing(tempPairing);
    setLoading(false);
  };

  useEffect(() => {
    if (preview) {
      getPreview();
    } else {
      getPairing();
    }
    // eslint-disable-next-line
  }, []);

  return (
    <>
      {loading && (modal ? <LinearProgress /> : <ModalLoadingFull />)}
      {pairing?.pairingType === "Pairing" ||
      pairing?.pairingType === "SeatedPairing" ||
      (pairing?.pairingType === "TeamPairing" &&
        pairing?.event?.doublesEvent) ? (
        <Pairing
          pairing={pairing}
          setPairing={setPairing}
          jwt={jwt}
          authContext={authContext}
          useGSD={useGSD}
          scorecardId={scorecardId}
          modal={modal}
          setRefreshPairings={setRefreshPairings}
          event={event}
          setSwapTableModal={setSwapTableModal}
          setP={setP}
          setModalOpen={setModalOpen}
          preview={preview}
        />
      ) : pairing?.pairingType === "TeamPairing" ? (
        <TeamPairing
          teamPairing={pairing}
          setTeamPairing={setPairing}
          jwt={jwt}
          authContext={authContext}
          useGSD={useGSD}
          scorecardId={scorecardId}
          modal={modal}
          setRefreshPairings={setRefreshPairings}
          event={event}
          setSwapTableModal={setSwapTableModal}
          setP={setP}
        />
      ) : (
        <></>
      )}
    </>
  );
}
